var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41981 15.375C3.19481 15.375 3.00606 15.3 2.85356 15.15C2.70119 15 2.625 14.8125 2.625 14.5875V12.1558C2.625 11.9741 2.68488 11.8116 2.80463 11.6683C2.92438 11.5251 3.07894 11.4284 3.26831 11.3784L5.35088 10.9543C5.53075 10.9293 5.70406 10.9413 5.87081 10.9903C6.03769 11.0394 6.17981 11.1251 6.29719 11.2472L7.98019 12.9448C8.51769 12.6409 9.01819 12.3126 9.48169 11.9597C9.94519 11.6068 10.3827 11.2246 10.7942 10.8129C11.2116 10.3986 11.5993 9.96375 11.9574 9.5085C12.3157 9.05313 12.6342 8.57019 12.9129 8.05969L11.1808 6.3735C11.0712 6.2735 10.9952 6.14994 10.9528 6.00281C10.9106 5.85569 10.9043 5.67975 10.9341 5.475L11.364 3.26831C11.4034 3.08656 11.4954 2.93394 11.6402 2.81044C11.7849 2.68681 11.952 2.625 12.1414 2.625H14.5875C14.8125 2.625 15 2.70119 15.15 2.85356C15.3 3.00606 15.375 3.19481 15.375 3.41981C15.375 4.83319 15.0464 6.25188 14.3891 7.67588C13.7319 9.1 12.8071 10.4106 11.6149 11.6077C10.4178 12.8048 9.106 13.7319 7.67963 14.3891C6.25312 15.0464 4.83319 15.375 3.41981 15.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.3aedab69d00360d6e20226664fcdb793.svg";
export { ForwardRef as ReactComponent };